import React from "react";
import { CiDeliveryTruck } from "react-icons/ci";

export default function OrderHeader({ orderDetail }) {
  return (
    <>
      <div className="text-[22px] font-[600] text-[#344054] mb-3">
        {orderDetail?.order_code}
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 text-sm mb-6">
        <div>
          <span className="text-[#667085] text-sm">Order Date:</span>{" "}
          <span className="font-[600] text-[#1D2939] text-base">{orderDetail?.order_date}</span>
        </div>
        <div className="flex text-green-600 sm:ml-4 text-[16px]">
          <CiDeliveryTruck className="text-lg font-bold mr-2" />
          Estimated delivery: <b>{" "}{orderDetail?.deliveryDate}</b>
        </div>
      </div>
    </>
  );
}
